import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

let _lang = localStorage.getItem('lang');
const ams_ja = require('./ams_ja.json')

const i18n = new VueI18n({
  locale: _lang,
  messages: {
    'ja': ams_ja,
    'en': ams_ja
  }
})


export default i18n


// WEBPACK FOOTER //
// ./src/message/i18n.js